export const tooltipStyles = `!bg-gray-900 !rounded-lg !p-2 !max-w-[400px] z-ltop`

export const tooltipContentContainerStyles = `flex flex-col gap-1`

export const tooltipTitleStyles = `text-xs-semibold text-base-white`

export const tooltipDescriptionStyles = `text-xs-medium text-gray-100`
